import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Text } from 'grommet';

const cardColors = [
  'linear-gradient(135deg, rgb(11, 58, 70) 0%, rgb(15, 118, 110) 100%)',
  'linear-gradient(135deg, rgb(30, 58, 138) 0%, rgb(37, 99, 235) 100%)',
  'linear-gradient(135deg, rgb(124, 45, 18) 0%, rgb(234, 88, 12) 100%)',
];

const ExecutiveTakeawaysPanel = ({
  piracyConcentration,
  leverageProviders,
  top3ProviderTrafficPct,
  chokePointDomains,
  primaryText = 'var(--page-primary-text)',
  secondaryText = 'var(--page-secondary-text)',
  cardBg = 'var(--page-alt-bg)',
}) => (
  <Box gap="1rem">
    <Grid columns={['1fr', '1fr', '1fr']} gap="0.75rem">
      <Box
        pad="1.1rem"
        round="var(--app-radius)"
        background={cardColors[0]}
        gap="0.5rem"
      >
        <Text size="0.68rem" color="#D5ECF3" style={{ letterSpacing: '0.06em' }}>
          PIRACY CONCENTRATION
        </Text>
        <Text size="0.9rem" color="white" weight={700}>
          {piracyConcentration || 'N/A'}
        </Text>
      </Box>
      <Box
        pad="1.1rem"
        round="var(--app-radius)"
        background={cardColors[1]}
        gap="0.5rem"
      >
        <Text size="0.68rem" color="#D5ECF3" style={{ letterSpacing: '0.06em' }}>
          LEVERAGE PROVIDERS
        </Text>
        <Text size="0.9rem" color="white" weight={700}>
          {leverageProviders || 'N/A'}
        </Text>
      </Box>
      <Box
        pad="1.1rem"
        round="var(--app-radius)"
        background={cardColors[2]}
        gap="0.5rem"
      >
        <Text size="0.68rem" color="#D5ECF3" style={{ letterSpacing: '0.06em' }}>
          TRAFFIC CHOKEPOINT
        </Text>
        <Box direction="row" gap="0.25rem" align="center">
          <Text size="1.35rem" color="white" weight={700}>
            {top3ProviderTrafficPct}
            %
          </Text>
          <Text size="0.7rem" color="#D5ECF3" style={{ paddingTop: '0.35rem' }}>
            traffic in top 3 providers
          </Text>
        </Box>
      </Box>
    </Grid>
    <Box gap="0.5rem">
      <Box
        pad="1.1rem"
        round="var(--app-radius)"
        background={cardBg}
        gap="0.5rem"
      >
        <Text size="0.72rem" color={primaryText} weight={700}>
          Strategic Enforcement Recommendation
        </Text>
        <Text color={secondaryText} size="0.78rem">
          Prioritize repeat-infrastructure domains and execute
          coordinated takedown waves around event windows.
        </Text>
      </Box>
      <Box
        pad="1.1rem"
        round="var(--app-radius)"
        background={cardBg}
        gap="0.5rem"
      >
        <Text size="0.72rem" color={primaryText} weight={700}>
          Infrastructure Choke Points
        </Text>
        <Text color={secondaryText} size="0.78rem">
          {chokePointDomains || 'No high-repeat infrastructure domains identified'}
        </Text>
      </Box>
      <Box
        pad="1.1rem"
        round="var(--app-radius)"
        background={cardBg}
        gap="0.5rem"
      >
        <Text size="0.72rem" color={primaryText} weight={700}>
          Recommended Long-Term Actions
        </Text>
        <Text color={secondaryText} size="0.78rem">
          Establish provider escalation SLAs, maintain recurring mirror-domain watchlists,
          and prioritize monitoring in the highest-concentration territories.
        </Text>
      </Box>
    </Box>
  </Box>
);

ExecutiveTakeawaysPanel.propTypes = {
  piracyConcentration: PropTypes.string,
  leverageProviders: PropTypes.string,
  top3ProviderTrafficPct: PropTypes.number,
  chokePointDomains: PropTypes.string,
  primaryText: PropTypes.string,
  secondaryText: PropTypes.string,
  cardBg: PropTypes.string,
};

export default ExecutiveTakeawaysPanel;
